import CourseCard from './CourseCard';
import Carousel from './Carousel';
import './CourseList.css';

export default function CourseList({ id, title, courses, emptyMessage, type="new" }) {
  if (!courses || courses.length === 0) {
    if (emptyMessage) {
      return (
        <section id={id} className="course-list course-list--empty">
          <div className="container">
            <h2 className="section-title">{title}</h2>
            <p className="course-list__empty">{emptyMessage}</p>
          </div>
        </section>
      );
    }
    return null;
  }

  return (
    <section id={id} className="course-list">
      <div className="container">
        <div className="course-list__header">
          <h2 className="section-title">{title}</h2>
          <span className="course-list__count">{courses.length} course{courses.length !== 1 ? 's' : ''}</span>
        </div>
        <Carousel>
          {courses.map((course) => (
            <CourseCard key={course.id} course={course} type={type}/>
          ))}
        </Carousel>
      </div>
    </section>
  );
}
